$shm_hitalama_map_page_contextmenu $mol_list
	map $shm_hitalama_map
	Map_page $shm_hitalama_map_page
	add_pos <= contextmenu_real_pos /
	contextmenu_showed? false
	query? \
	selected_id? \
	auto /
		<= search_focus null
	presets $shm_hitalama_map_widget_presets
		map <= map
	item_ids_top /
		\text
		\tsx
		\code_js
	item_ids_top2 /
		\code_html
		\code_css
		\code_sql
	item_ids /
		\text_md
		\input
		\iframe
		\range
		\date
		\select
		\button
		\table
		\echarts
		\tabulator
		\ai_request
		\opencode_session
		- \component_parser
		\form
		\deckgl_example
		\notebook
		\notebook2
		\layout_vert
		\layout_hor
		\secrets
		\customizer
		\form_custom
		\tg_ext
		\viewport_frame
		\tokens
		\posts
	Item_add* $shm_hitalama_map_page_contextmenu_add
		Icon <= item_icon* $mol_icon_square_outline
		title <= item_title* \
		click? <=> widget_add*? null
		attr_custom *
			widget_type <= id* \
			selected <= item_selected* false
	sub /
		<= Search $mol_string
			hint \Поиск..
			value? <=> query? \
			submit? <=> submit? null
			event *
				^
				keydown? <=> search_keydown? null
		<= List $mol_list
			rows <= rows /$mol_view
	Top $mol_view
		sub <= items_top /
	Top2 $mol_view
		sub <= items_top2 /
	Custom_add* $shm_hitalama_map_page_contextmenu_add
		Icon <= custom_add_icon* $mol_icon_plus
		title <= custom_add_title* \{title}
		click? <=> custom_add*? null
		attr_custom *
			selected <= custom_selected* false

$shm_hitalama_map_page_contextmenu_add $mol_button_minor
	Icon $mol_icon_square_outline
	sub /
		<= Icon
		<= title
	attr *
		^
		^ attr_custom *
